import React, { useEffect, useMemo, useRef, useState } from 'react';
import { CmsMapData } from './hooks/useCmsMapData';
import { useTranslation } from 'react-i18next';

export interface IMapMenu {
  show: boolean;
  data: CmsMapData[] | null;
  onChange: Function;
}

const MapMenu = ({ show, data, onChange }: IMapMenu) => {
  const { t } = useTranslation();

  return show ? (
    <div className="change-map-menu">
      <div className="change-map-menu-content">
        <ul>
          <h6>{t('map.chooseMap')}</h6>
          {data?.map((map) => (
            <li key={map.mapId}>
              <button className="change-map-menu-button" onClick={() => onChange(map.mapId)}>
                {map.mapId}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
};

export default MapMenu;
